import { RoomId, roomId, StreamId, streamId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomStreamActiveSetRequestDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomStreamActiveSetRequestDTO.validationSchema()
  );

  constructor(readonly data: RoomStreamActiveSetRequest) {
    JsonSchemaValidator.assert(RoomStreamActiveSetRequestDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "streamId"],
      properties: {
        roomId,
        streamId
      }
    };
  }
}

interface RoomStreamActiveSetRequest {
  roomId: RoomId;
  streamId: StreamId;
}
